/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardStatusDto } from './CardStatusDto';
import {
    CardStatusDtoFromJSON,
    CardStatusDtoFromJSONTyped,
    CardStatusDtoToJSON,
    CardStatusDtoToJSONTyped,
} from './CardStatusDto';

/**
 * Ensemble des statuts de cartes UI
 * @export
 * @interface CardStatuses
 */
export interface CardStatuses {
    /**
     * 
     * @type {CardStatusDto}
     * @memberof CardStatuses
     */
    insured: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof CardStatuses
     */
    risk: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof CardStatuses
     */
    conditions: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof CardStatuses
     */
    contract: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof CardStatuses
     */
    mandate?: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof CardStatuses
     */
    validation?: CardStatusDto;
}

/**
 * Check if a given object implements the CardStatuses interface.
 */
export function instanceOfCardStatuses(value: object): value is CardStatuses {
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('risk' in value) || value['risk'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    if (!('contract' in value) || value['contract'] === undefined) return false;
    return true;
}

export function CardStatusesFromJSON(json: any): CardStatuses {
    return CardStatusesFromJSONTyped(json, false);
}

export function CardStatusesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardStatuses {
    if (json == null) {
        return json;
    }
    return {
        
        'insured': CardStatusDtoFromJSON(json['insured']),
        'risk': CardStatusDtoFromJSON(json['risk']),
        'conditions': CardStatusDtoFromJSON(json['conditions']),
        'contract': CardStatusDtoFromJSON(json['contract']),
        'mandate': json['mandate'] == null ? undefined : CardStatusDtoFromJSON(json['mandate']),
        'validation': json['validation'] == null ? undefined : CardStatusDtoFromJSON(json['validation']),
    };
}

export function CardStatusesToJSON(json: any): CardStatuses {
    return CardStatusesToJSONTyped(json, false);
}

export function CardStatusesToJSONTyped(value?: CardStatuses | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insured': CardStatusDtoToJSON(value['insured']),
        'risk': CardStatusDtoToJSON(value['risk']),
        'conditions': CardStatusDtoToJSON(value['conditions']),
        'contract': CardStatusDtoToJSON(value['contract']),
        'mandate': CardStatusDtoToJSON(value['mandate']),
        'validation': CardStatusDtoToJSON(value['validation']),
    };
}

